import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage.js';
import { PrivacyConsentPage } from './pages/PrivacyConsentPage.js';
import { ChatPage } from './pages/ChatPage.js';
import { CompletionPage } from './pages/CompletionPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import { ExpiredPage } from './pages/ExpiredPage.js';
import { AlreadyRespondedPage } from './pages/AlreadyRespondedPage.js';
import { SurveyGuard } from './components/guards/SurveyGuard.js';
import { ConsentGuard } from './components/guards/ConsentGuard.js';
import { SurveyListPage } from './pages/dashboard/SurveyListPage.js';
import { ReportPage } from './pages/dashboard/ReportPage.js';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage.js';
import { TermsPage } from './pages/TermsPage.js';

const router = createBrowserRouter([
  {
    path: '/survey/:token',
    element: (
      <SurveyGuard>
        <LandingPage />
      </SurveyGuard>
    ),
  },
  {
    path: '/survey/:token/consent',
    element: (
      <SurveyGuard>
        <PrivacyConsentPage />
      </SurveyGuard>
    ),
  },
  {
    path: '/survey/:token/chat',
    element: (
      <SurveyGuard>
        <ConsentGuard>
          <ChatPage />
        </ConsentGuard>
      </SurveyGuard>
    ),
  },
  {
    path: '/survey/:token/complete',
    element: <CompletionPage />,
  },
  { path: '/dashboard', element: <SurveyListPage /> },
  { path: '/dashboard/:id', element: <ReportPage /> },
  { path: '/dashboard/login', element: <LoginPage /> },
  { path: '/privacy', element: <PrivacyPolicyPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/expired', element: <ExpiredPage /> },
  { path: '/already-responded', element: <AlreadyRespondedPage /> },
  { path: '*', element: <NotFoundPage /> },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
